//Θ(N) where N is the length of Emails

import { FACULTY_EMAIL_CODE, STUDENT_EMAIL_CODE } from '../../../../../common/constants';
import { Time } from '../../../../../common/MomentTime';

//Returns email address of user or impersonating user
export const getUserEmail = (user, impersonation) => {
  if (!impersonation.isImpersonating)
    //If not impersonating the user's email
    return user.email;

  let fEmail;
  let sEmail;

  //Else iterate over the emails list
  impersonation?.emails?.forEach((emailDetails) => {
    if (emailDetails.emailCode === FACULTY_EMAIL_CODE) fEmail = emailDetails.address;
    else if (emailDetails.emailCode === STUDENT_EMAIL_CODE) sEmail = emailDetails.address;
  });

  return fEmail ?? sEmail ?? impersonation.midas + '@odu.edu';
};

//Returns midas of user or impersonating user
export const getUserMidas = (user, impersonation) => {
  if (!impersonation.isImpersonating)
    // If not impersonating, return user's midas
    return user.midas;

  // Else return impersonating user's midas
  return impersonation.midas;
};

export const getDefaultAdhocStartEndTime = () => {
  let currentTime = Time.University();
  let startTime = '';
  let endTime = '';
  if (currentTime.minute() >= 30) {
    startTime = currentTime
      .add(60 - (currentTime.minute() % 60), 'minutes')
      .format('YYYY-MM-DDTHH:mm');
    endTime = currentTime
      .add(60 - (currentTime.minute() % 60) + 60, 'minutes')
      .format('YYYY-MM-DDTHH:mm');
  } else {
    startTime = currentTime
      .subtract(currentTime.minute() % 60, 'minutes')
      .format('YYYY-MM-DDTHH:mm');
    endTime = currentTime
      .add((currentTime.minute() % 60) + 60, 'minutes')
      .format('YYYY-MM-DDTHH:mm');
  }

  return { startTime, endTime };
};
